import i18n from 'i18next';
import {initReactI18next} from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import {de} from "./i18n/de/de";
import {en} from "./i18n/en/en";

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        load: 'languageOnly', // prevents en-US, uses just 'en'
        supportedLngs: ['en', 'de'],
        resources: {
            en: en,
            de: de
        }
    });

// export default i18n;
